import { initCloseOnScroll, initExpand } from "../utils/expand"

export function initTools() {
  initExpand(".tools-container .toggle", ".tools-container .tool")
  initCloseOnScroll(".tools-container nav.toggles")
}
